import { z } from "zod";

// Paridade com dc-not-empty do template legado: nome, nomeFantasia, email,
// cnpj, telefone, nomeUsuario, emailUsuario e usuario são obrigatórios.
// cep/rua/bairro/municipio/estado não têm validação nenhuma no legado.
export const franquiaSchema = z.object({
  nome: z.string().min(1, "Informe a razão social."),
  nomeFantasia: z.string().min(1, "Informe o nome fantasia."),
  email: z.string().min(1, "Informe o email.").email("Email inválido."),
  cnpj: z.string().min(1, "Informe o CNPJ."),
  telefone: z.string().min(1, "Informe o telefone."),
  cep: z.string().optional(),
  rua: z.string().optional(),
  bairro: z.string().optional(),
  municipio: z.string().optional(),
  estado: z.string().optional(),
  nomeUsuario: z.string().min(1, "Informe o nome do usuário."),
  emailUsuario: z.string().min(1, "Informe o email do usuário.").email("Email inválido."),
  usuario: z.string().min(1, "Informe o usuário."),
});

export type FranquiaFormValues = z.infer<typeof franquiaSchema>;
